import { FileExtensionEnum, MimeContentType, Nullable } from '@redngapps/shared/types';
import { isNil } from 'lodash-es';

import { normalizeFileExtension } from './normalize-file-extension';

const mimeContentTypeByExtension: Record<FileExtensionEnum, MimeContentType> = {
  [FileExtensionEnum.con]: MimeContentType.Text,
  [FileExtensionEnum.doc]: MimeContentType.Word,
  [FileExtensionEnum.docx]: MimeContentType.Docx,
  [FileExtensionEnum.gif]: MimeContentType.Gif,
  [FileExtensionEnum.html]: MimeContentType.Html,
  [FileExtensionEnum.jpeg]: MimeContentType.Jpg,
  [FileExtensionEnum.jpg]: MimeContentType.Jpg,
  [FileExtensionEnum.json]: MimeContentType.Json,
  [FileExtensionEnum.ldt]: MimeContentType.Text,
  [FileExtensionEnum.mp4]: MimeContentType.Mp4,
  [FileExtensionEnum.odt]: MimeContentType.Odt,
  [FileExtensionEnum.pad]: MimeContentType.Text,
  [FileExtensionEnum.pdf]: MimeContentType.Pdf,
  [FileExtensionEnum.png]: MimeContentType.Png,
  [FileExtensionEnum.rtf]: MimeContentType.Rtf,
  [FileExtensionEnum.tif]: MimeContentType.Tiff,
  [FileExtensionEnum.tiff]: MimeContentType.Tiff,
  [FileExtensionEnum.txt]: MimeContentType.Text,
  [FileExtensionEnum.xkm]: MimeContentType.Text,
  [FileExtensionEnum.xml]: MimeContentType.Xml,
  [FileExtensionEnum.zip]: MimeContentType.Zip,
};

export function getMimeContentTypeFromExtension(extension?: Nullable<string>): MimeContentType {
  const normalizedExtension = normalizeFileExtension(extension);

  return isNil(normalizedExtension) ? MimeContentType.Binary : mimeContentTypeByExtension[normalizedExtension];
}
